import React, { useContext, useEffect, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useImmer } from "use-immer";
import { useCostAndPriceQueries } from "./useCostAndPriceQueries";
import moment from "moment";
import { AppContext } from "../../../store/AppScopeProvider";

export const useCostAndPrice = ({ ingredientQuery, recipeId }) => {
  const { globalData } = useContext(AppContext);
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => message,
      validators: {
        cost: {
          required: true,
          message:
            "Please enter a number with not more than three decimal places",
          rule: (value) => {
            return /^[-]?(\d*\.\d{1,3}|\d+)$/.test(value);
          },
        },
      },
    }),
  );
  const costvalidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    }),
  );
  const { updateRetailPrice, updateOverHead } = useCostAndPriceQueries({
    recipeId,
  });
  const [state, setState] = useImmer({
    data: {},
    isEditoverHead: false,
    isEditPrice: false,
    isOpenSyncModal: false,
    isChanged: false,
  });
  useEffect(() => {
    if (ingredientQuery.isSuccess) {
      setState((draft) => {
        draft.data = {
          ...ingredientQuery.data,
          overhead_cost: ingredientQuery.data.overhead_cost || 0,
        };
      });
    }
  }, [ingredientQuery]);

  const onRetailPriceChange = (e) => {
    const { name, value } = e.target;
    const taxRate = state.data.recipe_tax;
    const taxAmount = (Number(value) * Number(taxRate)) / 100;
    if (name === "retailPriceExcGst") {
      const incGst = Number(value) + taxAmount;
      setState((draft) => {
        draft.data.retailPriceInGst = incGst?.toFixed(5); //before 3
      });
    } else if (name === "retailPriceInGst") {
      setState((draft) => {
        draft.data.retailPriceExcGst = (
          Number(value) *
          (100 / (100 + taxRate))
        ).toFixed(5); //before 3
      });
    }
    setState((draft) => {
      draft.data[name] = value;
    });
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setState((draft) => {
      draft.data[name] = value;
      draft.isChanged = true;
    });
  };
  const onEditClick = (name) => {
    setState((draft) => {
      draft[name] = !draft[name];
    });
  };

  const updateCostAndProfit = (data) => {
    setState((draft) => {
      draft.data.profit_percentage = data.profit_percentage;
      draft.data.cost_percentage = data.cost_percentage;
    });
  };

  const onUpdateRetailPriceClick = () => {
    if (validator.current.allValid()) {
      const payload = {
        retailprice_inc_tax: state.data.retailPriceInGst,
        retailprice_exc_tax: state.data.retailPriceExcGst,
      };
      updateRetailPrice.mutate({
        recipeId,
        payload,
        onEditClick,
        updateCostAndProfit,
      });
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const onUpdateOverHead = (e) => {
    if (costvalidator.current.allValid()) {
      state.isChanged && globalData?.pos_sync_settings?.[0]?.value
        ? handleSyncModal(true)
        : onUpdateOverHeadSubmit();
    } else {
      costvalidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const onUpdateOverHeadSubmit = () => {
    const payload = {
      overhead_cost: state.data.overhead_cost ? state.data.overhead_cost : 0,
      products_count: state.data.products_count ? state.data.products_count : 0,
      scheduled_date: state.data.scheduled_date
        ? moment(state.data.scheduled_date).format("YYYY-MM-DD")
        : null,
      sync_type: state.data.sync_type,
    };
    updateOverHead.mutate({
      recipeId,
      payload,
      onEditClick,
      updateCostAndProfit,
      handleSyncModal,
    });
  };

  const handleSyncModal = (state) => {
    setState((draft) => {
      draft.isOpenSyncModal = state;
      draft.data.sync_type = "scheduled";
    });
  };

  return {
    state,
    onChange,
    validator,
    onEditClick,
    onUpdateRetailPriceClick,
    onRetailPriceChange,
    costvalidator,
    onUpdateOverHead,
    updateOverHead,
    handleSyncModal,
    onUpdateOverHeadSubmit,
  };
};
